'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getOwnPropertyDescriptor = require('babel-runtime/core-js/object/get-own-property-descriptor');

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _desc, _value, _class, _class2, _temp;

var _react = require('react');

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _autobindDecorator = require('autobind-decorator');

var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);

var _projects = require('helpers/projects');

var _utils = require('helpers/utils');

var _toastr = require('helpers/toastr');

var _toastr2 = _interopRequireDefault(_toastr);

var _AudioPlayer = require('helpers/AudioPlayer');

var _AudioPlayer2 = _interopRequireDefault(_AudioPlayer);

var _downloads = require('helpers/downloads');

var _config = require('config');

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

var AlbumItem = (_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(AlbumItem, _Component);

  function AlbumItem() {
    (0, _classCallCheck3.default)(this, AlbumItem);
    return (0, _possibleConstructorReturn3.default)(this, (AlbumItem.__proto__ || (0, _getPrototypeOf2.default)(AlbumItem)).apply(this, arguments));
  }

  (0, _createClass3.default)(AlbumItem, [{
    key: 'gotoAlbum',
    value: function gotoAlbum(e) {
      var contentKey = this.props.album.contentKey;

      (0, _utils.stopEvent)(e);
      this.context.push('/playlists/fromkey/' + contentKey);
    }
  }, {
    key: 'isPlayingState',
    value: function isPlayingState() {
      var _props = this.props,
          playerStatus = _props.playerStatus,
          playerAlbum = _props.playerAlbum,
          album = _props.album;

      return playerStatus === _AudioPlayer2.default.status.play && playerAlbum.recipient_id === album.recipient_id;
    }
  }, {
    key: 'playPause',
    value: function playPause(e) {
      var _props2 = this.props,
          album = _props2.album,
          playAlbum = _props2.playAlbum,
          tracks = _props2.tracks;
      var t = this.context.t;


      if (album.audiovideo === _projects.projectTypes.video) {
        return false;
      }

      if (this.isPlayingState()) {
        (0, _utils.stopEvent)(e);
      }
      var albumTracks = tracks[album.project_id] || [];
      if (albumTracks.length) {
        playAlbum({ album: album, tracks: albumTracks });
      } else {
        _toastr2.default.error(t('No tracks'));
      }
    }
  }, {
    key: 'downloadPress',
    value: function downloadPress() {
      var _props3 = this.props,
          pressLoading = _props3.pressLoading,
          loadPress = _props3.loadPress,
          album = _props3.album;
      var t = this.context.t;


      if (pressLoading) {
        return _toastr2.default.info(t('Downloading is in progress'));
      }

      loadPress({ key: album.contentKey }).promise.then(function (resp) {
        var filename = resp.data.filename;

        if (filename) {
          (0, _downloads.download)('' + _config2.default.app.urlParts.press + filename);
        }
      });
    }
  }, {
    key: 'deleteAlbum',
    value: function deleteAlbum() {
      var _props4 = this.props,
          album = _props4.album,
          deletePlaylist = _props4.deletePlaylist;
      var t = this.context.t;

      var toastrConfirmOptions = {
        onOk: function onOk() {
          return deletePlaylist({ key: album.contentKey });
        }
      };
      _toastr2.default.confirm(t('Are you sure you want to delete this album?'), toastrConfirmOptions);
    }
  }]);
  return AlbumItem;
}(_react.Component), _class2.propTypes = {
  album: _propTypes2.default.object,
  deletePlaylist: _propTypes2.default.func,
  loadPress: _propTypes2.default.func,
  playAlbum: _propTypes2.default.func,
  playerAlbum: _propTypes2.default.object,
  playerStatus: _propTypes2.default.string,
  pressLoading: _propTypes2.default.bool,
  tracks: _propTypes2.default.object
}, _class2.contextTypes = {
  push: _propTypes2.default.func,
  t: _propTypes2.default.func
}, _class2.defaultProps = {
  album: {},
  tracks: {}
}, _temp), (_applyDecoratedDescriptor(_class.prototype, 'gotoAlbum', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'gotoAlbum'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'isPlayingState', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'isPlayingState'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'playPause', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'playPause'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'downloadPress', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'downloadPress'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'deleteAlbum', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'deleteAlbum'), _class.prototype)), _class);
exports.default = AlbumItem;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/AlbumItem/AlbumItem.js
// module id = 810
// module chunks = 1